import React, {useEffect, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Organization} from "../../../models/Organization.model";
import {Vehicle} from "../../../models/Vehicle.model";
import AdminVehicleService from "../../../services/adminVehicle.service";
import VehiclesList from "../common/VehiclesList.component";
import {CircularProgress} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {Page} from "../../../models/Page";

const useStyle = makeStyles(_theme => ({
    content: {
        padding: 20
    },
    nameInput: {
        width: 300,
        marginTop: 20,
        marginBottom: 40
    },
    actionButton: {
        marginLeft: 20
    }
}))

interface Props {
    organization: Organization;
}

const Vehicles = ({organization}: Props) => {

    // @ts-ignore
    const classes = useStyle();
    const [loading, setLoading] = useState(false);
    const [vehicles, setVehicles] = useState<Page<Vehicle>>();
    const history = useHistory();

    //region Handlers

    const fetch = async (page: number) => {
        setLoading(true);
        try {
            const response = await AdminVehicleService.getAllVehicles(page, 20, organization.id);
            setVehicles(response);
        } catch (e: any) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (organization.id) {
            fetch(0);
        }
    }, [organization.id])

    //endregion Handlers

    //region UI

    if (loading) {
        return <CircularProgress/>
    }

    return (
        <VehiclesList
            vehicles={vehicles}
            onVehicleClick={vehicle => {
                history.push(`/admin/vehicle/${vehicle.id}/basic`)
            }}

            onPageChange={page => fetch(page)}
        />
    )

    //endregion UI
}

export default Vehicles;